export default "__VITE_ASSET__OZz8ZMo___"